import { getRequest, patchRequest } from './api';
import { STORAGE_KEYS } from '../config/constants';

export const serviceRequestService = {
  // Get all service requests for manager's serving pincodes
  getServiceRequests: async (filters = {}) => {
    try {
      const userDataStr = localStorage.getItem(STORAGE_KEYS.USER_DATA);
      const userData = userDataStr ? JSON.parse(userDataStr) : null;

      const servingPincodes = userData?.servingPinCodes || [];

      const filter = {
        where: {
          partnerPincode: { inq: servingPincodes },   // lowercase 'c' — matches model field
          ...filters.where,
        },
        order: 'serviceDate DESC',
        include: [
          { relation: 'userReview' },
          { relation: 'service' },
          { relation: 'partner' },
        ],
        ...filters,
      };

      const response = await getRequest(`service-requests?filter=${JSON.stringify(filter)}`);
      return Array.isArray(response) ? response : [];
    } catch (error) {
      throw error;
    }
  },

  // Get service requests by status
  getServiceRequestsByStatus: async (status) => {
    try {
      return await serviceRequestService.getServiceRequests({
        where: { status },
      });
    } catch (error) {
      throw error;
    }
  },

  // Get single service request
  getServiceRequestById: async (requestId) => {
    try {
      const filter = {
        include: [
          { relation: 'userReview' },
          { relation: 'service' },
          { relation: 'partner' },
          { relation: 'customer' },
        ],
      };

      const response = await getRequest(`service-requests/${requestId}?filter=${JSON.stringify(filter)}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update service request status
  updateServiceRequestStatus: async (requestId, status) => {
    try {
      const response = await patchRequest(`service-requests/${requestId}`, { status });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get reviews with service requests
  getReviews: async () => {
    try {
      const userDataStr = localStorage.getItem(STORAGE_KEYS.USER_DATA);
      const userData = userDataStr ? JSON.parse(userDataStr) : null;
      const servingPincodes = userData?.servingPinCodes || [];

      const filter = {
        where: {
          partnerPincode: { inq: servingPincodes },   // lowercase 'c' — matches model field
          status: 'completed',
        },
        order: 'serviceDate DESC',
        include: [
          { relation: 'userReview' },
          { relation: 'service' },
        ],
      };

      const response = await getRequest(`service-requests?filter=${JSON.stringify(filter)}`);

      // Guard: ensure response is an array before filtering
      const data = Array.isArray(response) ? response : [];

      // Keep only records that have a userReview with a rating
      return data.filter(req => req.userReview != null);
    } catch (error) {
      throw error;
    }
  },
};

export default serviceRequestService;
